module.exports = __webpack_public_path__ + "img/data_moun_xj.360ad491.png";